import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  CHEQUE_TRANSACTIONS_DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchChequeTransactionDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_CHEQUE_TRANSACTION}/${gid}`);

const notifyChequeTransactionsDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_CHEQUE_TRANSACTION}/${gid}/notify`);

const patchChequePayment = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.GET_CHEQUE_TRANSACTION}/${gid}`, params);

export function* getChequeTransactionDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchChequeTransactionDetails, action.payload);
    yield put({ type: CHEQUE_TRANSACTIONS_DETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: CHEQUE_TRANSACTIONS_DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getNotifyChequeTransactionDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(notifyChequeTransactionsDetails, action.payload);
    yield put({ type: CHEQUE_TRANSACTIONS_DETAILS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.NOTIFY.SUCCESS,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: CHEQUE_TRANSACTIONS_DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* voidChequePayment(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchChequePayment, action.payload);
    const { data: { entity } } = yield call(fetchChequeTransactionDetails, action.payload.gid);
    yield put({ type: CHEQUE_TRANSACTIONS_DETAILS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.CASH_TRANSACTIONS.VOID_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
